/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Export
 */
export interface Export {
  /**
   *
   * @type {string}
   * @memberof Export
   */
  fileHandle: string
}

export function ExportFromJSON(json: any): Export {
  return ExportFromJSONTyped(json, false)
}

export function ExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Export {
  if (json === undefined || json === null) {
    return json
  }
  return {
    fileHandle: json['fileHandle'],
  }
}

export function ExportToJSON(value?: Export | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    fileHandle: value.fileHandle,
  }
}
